<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="height"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 18px; color: #2B3447; font-weight: bold;">{{
              $l('form_label_inspectionProductDetail') || '验货产品明细'
            }}</span>
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
            <b-button
              class="mr-2"
              size="sm"
              :disabled="!inspectionProductCode"
              v-if="!disabled"
              variant="outline-success"
              @click="openChooseOrderGoods()"
              >{{ $l('btn_label_chooseOrderGoods') || '选择订单出货产品' }}
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
          v-if="!disabled"
        >
          <i class="el-icon-delete tool-btn" @click="remove(row)"></i>
        </el-tooltip>
      </template>
    </vxe-grid>
    <choose-order-goods-dialog
      v-if="visible"
      :visible.sync="visible"
      :title="
        $l('INDEX.order_goods_label_orderGoods_information') || '订单产品信息'
      "
      :baseInfo="baseInfo"
      type="checkbox"
      @confirm="confirm"
    />
  </div>
</template>
<script>
import ChooseOrderGoodsDialog from '../choose-order-goods/dialog.vue'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
export default {
  components: {
    ChooseOrderGoodsDialog,
  },
  mixins: [EditLoading],
  props: {
    baseInfo: { type: Object, default: () => ({}) },
    height: { type: Number, default: 300 },
    disabled: { type: Boolean, default: false },
    inspectionProductCode: { type: String, default: '' },
  },
  mounted() {
    this.setTableData()
  },
  computed: {},
  data() {
    return {
      tableData: [],
      visible: false,
      loading: false,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    setTableData(code = '') {
      if (!this.inspectionProductCode && !code) return
      this.loading = true
      this.$api
        .dfInspectionProductDetailListApi({
          inspectionProductCode: this.inspectionProductCode || code,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    remove(row) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        },
      ).then((type) => {
        if (type === 'confirm') {
          this.$api
            .dfInspectionProductDetailDelApi({
              listInspectionProductDetailCode: [
                row.inspectionProductDetailCode,
              ],
              inspectionProductCode: this.inspectionProductCode,
              inspectionApplyCode: this.baseInfo.inspectionApplyCode,
            })
            .then(() => {
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
                type: 'success',
              })
              this.setTableData()
              this.$emit('reload')
            })
        }
      })
    },
    openChooseOrderGoods() {
      this.visible = true
    },
    goodsSpecDialogClose() {
      this.visible = false
    },

    confirm(params) {
      var info = params
        .map((t) => ({
          orderCode: t.orderCode,
          orderBatchCode: t.orderBatchCode,
          orderGoodsCode: t.orderGoodsCode,
          id: [t.orderGoodsCode, t.orderBatchCode].filter(Boolean).join('-'),
        }))
        .filter((i) => this.tableData.findIndex((j) => j.id === i.id) < 0)
      if (info.length === 0) {
        this.$message({
          showClose: true,
          message: this.$l('form_label_pl_dataExists') || '数据已存在',
          type: 'error',
        })
        return
      }
      this.loadingOpen()
      this.$api
        .dfInspectionProductDetailSaveApi({
          items: info,
          inspectionProductCode: this.inspectionProductCode,
          inspectionApplyCode: this.baseInfo.inspectionApplyCode,
        })
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.setTableData()
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
  },
}
</script>
